export default __webpack_public_path__ + "static/media/modal-close.b18a2aef.svg";